/**
 * Allowed post-login return targets for OfficeAPT auth bridge.
 * Keeps handoff redirects off arbitrary third-party hosts.
 */

const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '[::1]']);

function isPrivateOrLoopbackIp(hostname: string): boolean {
  if (LOCAL_HOSTS.has(hostname.toLowerCase())) return true;
  if (/^127\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(hostname)) return true;
  if (/^10\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(hostname)) return true;
  if (/^192\.168\.\d{1,3}\.\d{1,3}$/.test(hostname)) return true;
  const m = hostname.match(/^172\.(\d{1,3})\.\d{1,3}\.\d{1,3}$/);
  if (m) {
    const second = Number(m[1]);
    return second >= 16 && second <= 31;
  }
  return false;
}

/**
 * Validate a OfficeAPT app return URL after APT web login.
 * Allows: officeapt://…, exp://…, http(s) loopback/LAN, *.exp.direct, APT hosts.
 */
export function isAllowedOfficeaptAuthReturnUrl(raw: string): boolean {
  const trimmed = raw.trim();
  if (!trimmed || trimmed.length > 2048) return false;

  try {
    const u = new URL(trimmed);

    if (u.protocol === 'officeapt:') {
      return u.hostname === 'auth' || u.pathname === '/auth' || trimmed.startsWith('officeapt://auth');
    }

    if (u.protocol === 'exp:') {
      return true;
    }

    if (u.protocol !== 'http:' && u.protocol !== 'https:') {
      return false;
    }

    const host = u.hostname.toLowerCase();
    if (isPrivateOrLoopbackIp(host)) return true;
    if (host.endsWith('.exp.direct')) return true;
    if (host === 'americanpolicetraining.com' || host.endsWith('.americanpolicetraining.com')) {
      return true;
    }
    return false;
  } catch {
    return false;
  }
}

/** Default deep link when native OfficeAPT opens the bridge without ?return=. */
export const OFFICEAPT_DEFAULT_AUTH_RETURN = 'officeapt://auth';
